import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../../styles/PerformanceDashboard.module.css';

interface BreadcrumbNavProps {
  groupId: string;
  groupName?: string;
  currentPage: string;
}

const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({ groupId, groupName, currentPage }) => {
  const navigate = useNavigate();

  return (
    <nav className={styles.breadcrumbNav}>
      <div className={styles.navPath}>
        <button 
          className={styles.navLink}
          onClick={() => navigate('/group-management/groups')}
        >
          Groups
        </button>
        <span className={styles.navSeparator}>/</span>
        {groupName && (
          <>
            <button 
              className={styles.navLink}
              onClick={() => navigate(`/group-management/groups/${groupId}/overview`)}
            >
              {groupName}
            </button>
            <span className={styles.navSeparator}>/</span>
          </>
        )}
        <button 
          className={styles.navLink}
          onClick={() => navigate(`/group-management/groups/${groupId}/user-management`)}
        >
          User Management
        </button>
        <span className={styles.navSeparator}>/</span>
        <span className={styles.navCurrent}>
          {currentPage}
        </span>
      </div>
    </nav>
  );
};

export default BreadcrumbNav;

